import { useEffect, useState } from 'react';
import Modal from 'react-modal';
import './trackPopUp.css';
import { useLocation } from "react-router-dom";
import axios from 'axios';
import { useMsal } from "@azure/msal-react";
// import { loginRequest } from "./authConfig";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from '../../authConfig';

export default function TrackPopUp(props) {

  const msalInstance = new PublicClientApplication(msalConfig);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const userName = activeAccount.username;
  // {console.log(activeAccount.username, "activeAccounttttt")}


  const [modalIsOpen, setIsOpen] = useState(false);
  const [fileName, setFileName] = useState('sample.xlsx');

  let location = useLocation();
  let url = 'https://atci.lkm.qa.accenture.com/qa-apis/';

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  const customStyles = {
    content: {
      top: '31%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: '90%',
      backgroundColor: '#9b93a4e0'
    },
  };

  const addRow = () => {
    let empTab = document.getElementById('empTable');
    let rowCnt = empTab.rows.length;
    let tr = empTab.insertRow(rowCnt);
    tr = empTab.insertRow(rowCnt);
    for (let c = 0; c < 16; c++) {
      let td = document.createElement('td');
      td = tr.insertCell(c);
      let ele = document.createElement('input');
      ele.setAttribute('type', 'text');
      ele.setAttribute('value', '');
      td.appendChild(ele);
    }
  }

  // const addDataRow = (data) => {      
  //   let empTab = document.getElementById('empTable');  
  //   let rowCnt = empTab.rows.length;   
  //   let tr = empTab.insertRow(rowCnt); 
  //   tr = empTab.insertRow(rowCnt);
  //   let c = 0;
  //   for (let key in data) {        
  //     let td = document.createElement('td');
  //     td = tr.insertCell(c++);
  //       let ele = document.createElement('input');
  //       ele.setAttribute('type', 'text');
  //       ele.setAttribute('value', data[key]);
  //       td.appendChild(ele);        
  //   }
  // }

  const getDocuments1 = () => {
    if (process.env.NODE_ENV === 'development') {
      url = 'http://localhost:3021';
    }
    axios.get(url,
      {
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
          'Authorization': localStorage.getItem("token"),
          'Content-Type': 'application/json'
        }
      }
    )
      .then(res => {
        console.log('hi2');
        props.setDocuments(res.data.results);
      })
      .catch(err => console.log(err));
  }

  const submitData = (docId) => {
    let myTab = document.getElementById('empTable');
    let arrValues = [];
    for (let row = 1; row < myTab.rows.length - 1; row++) {
      for (let c = 0; c < myTab.rows[row].cells.length; c++) {
        let element = myTab.rows.item(row).cells[c];
        if (element.childNodes[0].getAttribute('type') == 'text') {
          arrValues.push(element.childNodes[0].value);
        }
      }
    }

    let custs = [];
    let lenArr = arrValues.length;
    let val = Math.ceil(lenArr / 16);
    let count = 0;
    for (let i = 0; i < val; i++) {
      custs.push({
        Sl: arrValues[count],
        category: arrValues[count + 1],
        capability: arrValues[count + 2],
        CourseCode: arrValues[count + 3],
        CourseName: arrValues[count + 4],
        CourseDescription: arrValues[count + 5],
        CourseLevel: arrValues[count + 6],
        prerequisite: arrValues[count + 7],
        CareerLevels: arrValues[count + 8],
        duration: arrValues[count + 9],
        mode: arrValues[count + 10],
        onlineType: arrValues[count + 11],
        courseLink: arrValues[count + 12],
        learningOutcomes: arrValues[count + 13],
        courseStatus: arrValues[count + 14],
        remarks: arrValues[count + 15]
      })
      count = count + 16;
    }

    if (docId === 0) {
      let uploadPath = location.pathname.slice(8);

      if (process.env.NODE_ENV === 'development') {
        url = 'http://localhost:3021/';
        // alert(`you are not allowed to create a file from development environment.`);            
        // return;        
      }
      // console.log(userName,"usernameee")
      axios.post(
        `${url}document/add`,
        {
          'enterprise_id': userName,
          'doc_path': uploadPath,
          'doc_data': custs,
          'doc_name': fileName
        },
        {
          headers: {
            'Authorization': localStorage.getItem("token"),
            'Content-Type': 'application/json'
          }
        }
      )
        .then(res => {
          getDocuments1();
          closeModal();
          console.log('added');
        })
        .catch(err => console.log(err))
    } else {
      // axios.post(
      //   `http://localhost:3021/document/edit/${docId}`,
      //   {                            
      //     'doc_data': custs,
      //     'doc_name': fileName
      //   }
      // )
      // .then(res => {
      //   getDocuments1();
      //   closeModal();
      //     console.log('Edited');
      // })
      // .catch(err => console.log(err))
    }
  }

  // const handleEdit = () => {        
  //   axios({
  //       method: 'get',
  //       url: `http://localhost:3021/document/${props.docId}`,            
  //   })
  //   .then(res => {          
  //       openModal();          
  //       console.log(res);
  //       setFileName(res.data.filename);
  //       res.data.data.forEach(element => {
  //         addDataRow(element);
  //       });                              
  //   })
  //   .catch(err => console.log(err))    
  // }    

  return (
    <>
      {props.docId === 0 ?
        <button className='track-file-upload-btn track-technlogy-addBtn' onClick={openModal}>Create File</button> :
          /*<button className='track-technology-move' onClick={handleEdit}>Edit</button>*/ ""}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
      >
        <div className='track-popup-input'>
          <label style={{ fontWeight: 'bold' }}>Enter file name : &nbsp;&nbsp;</label>
          <input type="text" value={fileName} onChange={(e) => { setFileName(e.target.value) }} />
        </div>
        <table id='empTable'>
          <tr>
            <th>Sl.#</th>
            <th>Category</th>
            <th>Capability</th>
            <th>Course Code</th>
            <th>Course Name</th>
            <th>Course Description</th>
            <th>Course Level (Introductory, Intermediate, Advanced)</th>
            <th>Pre-requisite</th>
            <th>Career Levels (numeric /All)</th>
            <th>Duration (hours)</th>
            <th>Mode (Classroom/Virtual Classroom/Blended/Online)</th>
            <th>Online Type (Percipio/ Learning Board/ Plural Sight/ Others)</th>
            <th>Course Link (for Online courses)</th>
            <th>Learning Outcomes</th>
            <th>Course Status (Active/Retired)</th>
            <th>Remarks</th>
          </tr>
        </table>
        <div className='track-popup-btns'>
          <input className='btn dropdown add track-popup-btn' type="button" value="Add Row" onClick={addRow}></input>
          <input className='btn dropdown submit track-popup-btn' type="button" value="Submit" onClick={() => submitData(props.docId)}></input>
          <button onClick={closeModal} className="track-popup-btn">close</button>
        </div>
      </Modal>
    </>
  )
}